<template>
  <TitleCard :title="titleCard" :showMore="showMore">
    <div class="backStack-table-wrap">
      <div class="head-top-wrap">
        <TableTotalWrap
          :result="totalCounts"
          :auditStatus="auditStatus"
          @change="handlerStatusCheck"
        ></TableTotalWrap>
        <div class="form-table-wrap">
          <Form
            ref="form"
            layoutType="grid"
            :optionList="formRow"
            :defaultModel="defaultValue"
          ></Form>
          <div class="operation-wrap">
            <a-button @click="clearAll">清空条件</a-button>
            <a-button @click="toSearch">搜索</a-button>
          </div>
        </div>
        <TableToolsWrap
          needLeft
          :btnList="utilsBtnList"
          @utilsClick="handlerActionClick"
        ></TableToolsWrap>
      </div>
      <Table
        ref="table"
        :options="fields"
        :tableValue="tableValue"
        :customSlotOpt="slotOpt"
        :otherOpt="customOtherOpt"
        @change="initTableValue"
        @actionClick="handlerActionClick"
      ></Table>
    </div>
    <AModal ref="modal" :customOpt="customModalOpt" @ok="handlerOk"></AModal>
  </TitleCard>
</template>

<script>
import { mapGetters } from 'vuex'
import Table from '../../components/table/index.vue'
import Form from '../../components/formTable/form.vue'
import AModal from '../../components/AModal'
import TableToolsWrap from '../../components/common/tableToolsWrap.vue'
import TableTotalWrap from '../../components/common/tableTotalWrap.vue'
import mixinsBackStack from '@/views/backstageSupport/mixins'
import { fields, slotOpt, formRow } from './configs/configs'
import {
  getTotalCounts,
  getServerInfo,
  deleteServerInfo,
  issueServerInfo,
  downServerInfo
} from '@/api/serverInfo.js'

export default {
  mixins: [mixinsBackStack],
  data() {
    return {
      slotOpt,
      fields,
      formRow,
      tableValue: [],
      utilsBtnList: [],
      totalCounts: [], // 统计数量
      defaultSearchParam: {},
      auditStatus: '0',
      defaultValue: {
        searchValue: 0
      },
      // 分页配置
      customOtherOpt: {
        pagination: {
          pageNum: 1,
          pageSize: 10,
          total: 0
        }
      }
    }
  },
  components: {
    Table,
    Form,
    AModal,
    TableTotalWrap,
    TableToolsWrap
  },
  mounted() {
    this.initSearchParams() // 重置搜索的参数
    this.initTableValue()
    this.handlerTableSlot()
    this.getTotalCount(getTotalCounts) // 获取表格的统计数量--mixins中
    this.handlerTableHeadOperationBtn() // 表格上方的操作按钮
  },
  computed: {
    ...mapGetters('user', ['role'])
  },
  methods: {
    handlerStatusCheck(v) {
      this.auditStatus = v
      this.initSearchParams() // 重置搜索的参数
      this.initPagination()
      // 处理操作栏
      this.handlerTableSlot()
      this.handlerTableHeadOperationBtn() // 表格上方的操作按钮
      this.initTableValue()
    },
    async initTableValue() {
      try {
        this.loadingTable(true)
        const params = this.handlerBeforeRequestParams()
        const { data } = await getServerInfo(params)
        const { rows, total } = data
        const row = this.handlerDateFormat(rows)
        this.handlerResultMappings(row) // 处理数据的映射关系
        this.tableValue = row
        this.customOtherOpt.pagination.total = total
        this.initSelectedRowIds() // 清空勾选的选项
      } catch (error) {
        this.$apiStatusHandler(99, error.msg)
      } finally {
        this.loadingTable(false)
      }
    },
    // 请求前的参数收集
    handlerBeforeRequestParams() {
      const { pagination } = this.$refs.table
      const { pageSize, pageNum } = pagination
      const params = {
        ...this.searchParam,
        pageNum,
        pageSize
      }
      return params
    },
    // 批量发布接口
    async batchUp(params) {
      try {
        const { msg, code } = await issueServerInfo(params)
        this.initTableValue()
        this.getTotalCount(getTotalCounts) // 获取表格的统计数量--mixins中
        this.$apiStatusHandler(code, msg)
      } catch (error) {
        this.$apiStatusHandler(99, error.msg)
      }
    },
    // 批量下架接口
    async batchLow(params) {
      try {
        const { msg, code } = await downServerInfo(params)
        this.initTableValue()
        this.getTotalCount(getTotalCounts) // 获取表格的统计数量--mixins中
        this.$apiStatusHandler(code, msg)
      } catch (error) {
        this.$apiStatusHandler(99, error.msg)
      }
    },
    // 批量发布
    issue() {
      const ids = this.$refs.table.selectedRowIds
      const id = ids.map(item => item.id)
      this.customModalOpt.contentTips = '是否确定发布已选的服务信息信息'
      if (id.length === 0) {
        return this.$apiStatusHandler(999, '您还未选中需要操作的服务信息信息')
      }
      this.beforeShowModal(true, {
        source: 'batchUp',
        params: id
      })
    },
    // 批量下架
    drop() {
      const ids = this.$refs.table.selectedRowIds
      const id = ids.map(item => item.id)
      this.customModalOpt.contentTips = '是否确定下架已选的服务信息信息'
      if (id.length === 0) {
        return this.$apiStatusHandler(999, '您还未选中需要操作的服务信息信息')
      }
      this.beforeShowModal(true, {
        source: 'batchLow',
        params: id
      })
    },
    // 批量删除
    async batchDelete() {
      const ids = this.$refs.table.selectedRowIds
      const id = ids.map(item => item.id)
      this.customModalOpt.contentTips = '是否确定删除已选的服务信息信息'
      if (id.length === 0) {
        return this.$apiStatusHandler(999, '您还未选中需要操作的服务信息信息')
      }
      const selectId = id.join(',')
      this.beforeShowModal(true, {
        source: 'dealDeleteApi',
        params: { ids: selectId }
      })
    },
    // 单个删除
    async delete(row) {
      this.customModalOpt.contentTips = '是否确定删除该服务信息信息'
      this.beforeShowModal(true, {
        source: 'dealDeleteApi',
        params: { ids: row.id }
      })
    },
    // 调用删除接口
    async dealDeleteApi(params) {
      const { ids } = params
      try {
        const { msg, code } = await deleteServerInfo(ids)
        this.initTableValue()
        this.getTotalCount(getTotalCounts) // 获取表格的统计数量--mixins中
        this.$apiStatusHandler(code, msg)
      } catch (error) {
        this.$apiStatusHandler(99, error.msg)
      }
    },
    toDetail(row) {
      const { id } = row.scope
      this.$router.push({
        name: 'ServerInfosCreate',
        query: { type: 'detail', id }
      })
    },
    edit(row) {
      const { id } = row
      this.$router.push({
        name: 'ServerInfosCreate',
        query: { type: 'edit', id }
      })
    },
    // 新增
    addServer() {
      this.$router.push({ name: 'ServerInfosCreate' })
    },
    handlerTableSlot() {
      const status = this.auditStatus
      const target = this.slotOpt.find(item => item.slot === 'action')
      if (!target) return
      let initSlot = [{ name: '删除', cb: 'delete' }]
      if (status === '2') {
        initSlot = [
          { name: '编辑', cb: 'edit' },
          { name: '删除', cb: 'delete', divider: true }
        ]
      }
      // 审核通过的，企业用户没有删除权限
      if (status === '1' && this.role === 'user') {
        initSlot = []
      }
      target.list = initSlot
    },
    // 处理表格头部的控制按钮的显示
    handlerTableHeadOperationBtn() {
      const forbiddenMap = ['0', '2'] // 待审核 和 不通过不显示发布和下架功能
      let utilsBtnList = [{ name: '新增', cb: 'addServer' }]
      if (!forbiddenMap.includes(this.auditStatus)) {
        utilsBtnList = [
          { name: '新增', cb: 'addServer' },
          { name: '发布', cb: 'issue' },
          { name: '下架', cb: 'drop' }
        ]
        console.log(localStorage.getItem('role'))
        // let role = localStorage.getItem('role')
        // if (role === 'user') {
        //   utilsBtnList = [{ name: '新增', cb: 'addServer' }]
        // }
        // 企业用户没有发布、下架权限
        if (this.role === 'user') {
          utilsBtnList = [{ name: '新增', cb: 'addServer' }]
        }
      }
      this.utilsBtnList = utilsBtnList
    }
  }
}
</script>
